import { FigmaNode, FlattenedNode } from '../types/figma';

/**
 * Flatten a Figma node tree into a flat array for hit detection and tree display.
 */
export function flattenNodes(
  nodes: FigmaNode[],
  depth = 0,
  parentId?: string
): FlattenedNode[] {
  const result: FlattenedNode[] = [];

  for (const node of nodes) {
    result.push({
      id: node.id,
      name: node.name,
      type: node.type,
      depth,
      absoluteBoundingBox: node.absoluteBoundingBox,
      parentId,
    });

    if (node.children) {
      result.push(...flattenNodes(node.children, depth + 1, node.id));
    }
  }

  return result;
}

/**
 * Find the deepest node at a given absolute position.
 */
export function findNodeAtPosition(
  nodes: FlattenedNode[],
  x: number,
  y: number
): FlattenedNode | null {
  // Iterate in reverse to find the deepest (most specific) node first
  for (let i = nodes.length - 1; i >= 0; i--) {
    const node = nodes[i];
    const bbox = node.absoluteBoundingBox;
    if (bbox && x >= bbox.x && x <= bbox.x + bbox.width && y >= bbox.y && y <= bbox.y + bbox.height) {
      return node;
    }
  }
  return null;
}
